<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, nextTick, watch } from "vue";
import { Globals } from "@/Globals";
import { showSnackbar } from "@/UIHelper";
import {
  getDisplay,
  getDisplayValue,
  getKZValue,
  getValue,
  toNumber,
} from "@/DataHelper";
import { begriffBezeichnung, globalsBezeichnung } from "@/local";
import { SliderConfig } from "./BaseFilterSlider.vue";

import CommonBaseFilterSlider from "@/components/common/BaseFilterSlider.vue";
const emit = defineEmits([
  "back",
  "filterChanged",
  "reloadData",
  "filteredDataChanged",
  "groupColumnChanged",
  "setIsWeg",
]);
const props = defineProps<{
  queryData: QueryResponse;
  colorUbergabe?: string;
  showVorAustritt?: boolean;
}>();

let filterColumns = ref<FilteredDataColumn[] | null>(null);
let groupColumns = ref<DataColumn[] | null>(null);
let groupColumn = ref<DataColumn | null>(null);
let textSearchColumnKZ: string[] = [
  "titel",
  "header",
  "subtitel",
  "name",
  "subject",
];

let menu = ref<boolean>(false);
let filteredRows: QueryDataRow[] = [];
let searchText = ref<string>("");
let emptyFilterText: string = "- leer -";
let emptyGroupText: string = "- leer -";

let color = ref<string>("white");

let currentVal: any = null;
let enableFilter = ref<boolean>(true);
let localName!: string;
let selectVorAustritt = ref<boolean>(false);
let searchTextColumns: DataColumn[] = [];
let sliderConfig: SliderConfig[] = [];
let initAll = ref<boolean>(false);

let datarows: QueryData;
// watch("queryData");
function onQueryDataChanged() {
  console.log("baseFilter querydata length: " + props.queryData?.data?.length);
}
let columns = props.queryData?.columns;

function header() {
  return props.queryData?.header;
}

onMounted(async () => {
  localName = AUApi.Current.user.bezeichnung + props.queryData.header.kennung;
  color.value = props.colorUbergabe ?? "white";
  if (!props.queryData) {
    console.log("no query data!");
    return;
  }
  datarows = props.queryData.data;
  await refreshFilter();
  updateFilteredRows();

  localName = AUApi.Current.user.bezeichnung + props.queryData.header.kennung;
  const localParameter: string = enableFilter.value.toString();
  window.localStorage.setItem(localName, localParameter);
});

function getSlider(col: DataColumn) {
  return sliderConfig.find((s) => s.filterCol === col);
}

async function refreshFilter(reset?: boolean) {
  try {
    searchTextColumns = props.queryData.columns.filter(
      (c) => c.meta.kz && textSearchColumnKZ.indexOf(c.meta.kz) >= 0
    );
    const filterColumnsLocal: FilteredDataColumn[] = (filterColumns.value =
      columns.filter(
        (c: any) =>
          c.meta.filterOK === true && !c.meta.invisible && !c.meta.banned
      ) as FilteredDataColumn[]);

    if (!filterColumnsLocal || filterColumnsLocal.length === 0) {
      console.log("no filtered columns found!");
      return;
    }
    const filterALL = columns.find((c: any) => c.meta.filterInit === true);
    if (filterALL) {
      initAll.value = true;
      enableFilter.value = false;
      if (localStorage.getItem(localName)) {
        const localFilter = localStorage.getItem(localName);
        let boolFilter = false;
        if (localFilter === "true") {
          boolFilter = true;
          color.value = "green";
        }
        enableFilter.value = boolFilter;
      }
    }
    sliderConfig = [];
    const data: QueryData = datarows;
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      if (filterColumns.value.length > 0) {
        filterColumns.value.forEach((fc, ix) => {
          const isCheckbox = fc.type === "checkBox";
          const isCheckbox3 = fc.type === "checkBox3";
          if (reset) {
            fc.filterValues = [];
          }
          if (!fc.filterValues) {
            fc.filterValues = [];
          }
          const filterVal = getDisplay(row, fc) ?? emptyFilterText;
          const filterAic = getValue(row, fc, true);
          const setFilter = fc.meta.value;
          if (isCheckbox && fc.filterValues.length === 0) {
            fc.filterValues.push({
              checked: setFilter?.length === 1 && setFilter[0] === true,
              value: filterVal,
            });
            fc.filterSwitchValue =
              setFilter?.length === 1 && setFilter[0] === true;
            return;
          }
          if (fc.type === "slider") {
            let sl = getSlider(fc);
            const sliderVal = toNumber(filterAic);
            if (sliderVal) {
              if (!sl) {
                sl = { filterCol: fc, min: sliderVal, max: sliderVal };
                sliderConfig.push(sl);
                return;
              }
              if (sl.min > sliderVal) {
                sl.min = sliderVal;
              }
              if (sl.max < sliderVal) {
                sl.max = sliderVal;
              }
              return;
            }
          }
          if (filterVal && filterVal !== "- leer -") {
            if (!fc.filterValues.find((f: any) => f.value === filterVal)) {
              let checked = true;
              if (setFilter && !isCheckbox3) {
                const comboData = fc.meta.combo;
                if (!isCheckbox3 && !isCheckbox && comboData) {
                  for (let j = 0; j < comboData.length; j++) {
                    const metaRow = comboData[j];
                    if (
                      !fc.filterValues.find(
                        (f: any) => f.value === metaRow.bezeichnung
                      )
                    ) {
                      if (setFilter.indexOf(metaRow.aic) >= 0) {
                        checked = true;
                      } else {
                        checked = false;
                      }
                      fc.filterValues.push({
                        checked,
                        value: metaRow.bezeichnung,
                        aic: metaRow.aic,
                      });
                    }
                  }
                } else if (setFilter.indexOf(filterAic) >= 0) {
                  checked = true;
                  if (isCheckbox && filterAic) {
                    fc.filterSwitchValue = isCheckbox; // setzen wenn true und checkbox
                  }
                } else {
                  checked = false;
                }
                // muss gesetzt werden, damit zB Kostenstellen als
                // Filter angezeigt werden wenn sie gespeichert wurden!
                fc.filterValues.push({
                  checked,
                  value: filterVal,
                  aic: filterAic,
                });
              } else if (isCheckbox3) {
                if (initAll.value && setFilter) {
                  const checkALL = setFilter.find((f: any) => f === "initAll");
                  enableFilter.value = true;
                  if (localStorage.getItem(localName)) {
                    const localFilter = localStorage.getItem(localName);
                    let boolFilter = false;
                    if (localFilter === "true") {
                      boolFilter = true;
                    }
                    enableFilter.value = boolFilter;
                  } else {
                    const localParameter: string =
                      enableFilter.value.toString();
                    window.localStorage.setItem(localName, localParameter);
                  }
                }
                const meta = fc.meta;
                checked = true;
                const combo = meta.combo;
                if (combo && combo.length > 0) {
                  const text1 = combo[0].bezeichnung;
                  const text2 = combo[1].bezeichnung;
                  const text3 = combo[2].bezeichnung;

                  const value1 = combo[0].nr;
                  const value2 = combo[1].nr;
                  const value3 = combo[2].nr;

                  const aic1 = combo[0].aic;
                  const aic2 = combo[1].aic;
                  const aic3 = combo[2].aic;
                  if (setFilter) {
                    const check1 = setFilter.find((f: any) => f === aic1);
                    checked = check1 ? checked : false;
                    fc.filterValues.push({
                      checked,
                      value: text1,
                      aic: aic1,
                    });
                    checked = true;
                    const check2 = setFilter.find((f: any) => f === aic2);
                    checked = check2 ? checked : false;
                    fc.filterValues.push({
                      checked,
                      value: text2,
                      aic: aic2,
                    });
                    checked = true;
                    const check3 = setFilter.find((f: any) => f === aic3);
                    checked = check3 ? checked : false;
                    fc.filterValues.push({
                      checked,
                      value: text3,
                      aic: aic3,
                    });
                  } else {
                    fc.filterValues.push({
                      checked,
                      value: text1,
                      aic: aic1,
                    });
                    fc.filterValues.push({
                      checked,
                      value: text2,
                      aic: aic2,
                    });
                    fc.filterValues.push({
                      checked,
                      value: text3,
                      aic: aic3,
                    });
                  }
                }
              } else {
                const comboData = fc.meta.combo;
                if (comboData) {
                  for (let j = 0; j < comboData.length; j++) {
                    const metaRow = comboData[j];
                    fc.filterValues.push({
                      checked,
                      value: metaRow.bezeichnung,
                      aic: metaRow.aic,
                    });
                  }
                } else {
                  fc.filterValues.push({
                    checked,
                    value: filterVal,
                    aic: filterAic,
                  });
                }
              }
            }
            fc.filterValues.sort(dynamicSort("value"));
          }
        });
      }
    }
  } catch (e) {
    console.error("error creating filter:" + e);
  }
}
async function resetFilter() {
  if (filterColumns.value && filterColumns.value.length > 0) {
    if (!initAll.value) {
      filterColumns.value.forEach((fc: any, ix) => {
        if (fc.type === "checkBox") {
          fc.filterSwitchValue = false;
        }
        if ((fc.filterValues?.length ?? 0) > 0) {
          for (let j = 0; j < fc.filterValues.length; j++) {
            fc.filterValues[j].checked = true;
          }
        }
      });
    } else if (enableFilter.value) {
      filterColumns.value.forEach((fc: any, ix) => {
        if (fc.type === "checkBox") {
          fc.filterSwitchValue = false;
        }
        if ((fc.filterValues?.length ?? 0) > 0) {
          for (let j = 0; j < fc.filterValues.length; j++) {
            fc.filterValues[j].checked = true;
          }
        }
      });
    }
  }
  // sliders zurücksetzen...
  sliderConfig.forEach((sl) => (sl.range = [sl.min, sl.max]));
  color.value = props.colorUbergabe ?? "white";
  searchText.value = "";
  await refreshFilter();
  groupColumns.value = [];
  await groupColumnChanged();
  await updateFilteredRows();
  emit("reloadData");
}
function dynamicSort(property: any) {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return (a: any, b: any) => {
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

function setUserPara(noSave?: boolean) {
  const varUbergabe: VarUebergabe[] = [];
  let value: any[] = [];
  const cols = filterColumns.value;
  if (cols && cols.length > 0) {
    for (let i = 0; i < cols.length; i++) {
      // if (!cols[i].filterSwitchValue) {
      // das hab ich dazu getan - weil bei false - immer undefinded drinnen steht...
      //   cols[i].filterSwitchValue = false;
      // }
      if (cols[i].type === "checkBox") {
        varUbergabe.push({
          aic: cols[i].aic,
          value: [cols[i].filterSwitchValue ?? false],
        });
        continue;
      }
      const filterItems = cols[i].filterValues ?? [];
      value = [];
      const valueList = filterItems.filter((c: any) => c.checked === true);
      for (let j = 0; j < valueList.length; j++) {
        if (valueList[j].aic || valueList[j].aic === 0) {
          value.push(valueList[j].aic);
        }
      }
      if (initAll.value && cols[i].type === "checkBox3") {
        value.push("initAll");
      }
      varUbergabe.push({
        aic: cols[i].aic,
        value,
      });
    }
  }
  if (groupColumns.value) {
    if (groupColumn.value) {
      varUbergabe.push({
        aic: groupColumn.value.aic,
        pGruppiert: true,
      });
    } else if (groupColumns.value && groupColumns.value.length > 0) {
      varUbergabe.push({
        aic: groupColumns.value[0].aic,
        pGruppiert: false,
      });
    }
  }
  color.value = "green";
  const success = "";
  AUApi.Current.setPersParameter(varUbergabe, success, noSave);
}
async function deleteUserPara(notSave?: boolean) {
  const filter = enableFilter.value;
  const aicBegriff = props.queryData.header.aicBegriff;
  AUApi.Current.deletePersParameter(aicBegriff, notSave).then((x: any) =>
    resetFilter()
  );
}
async function resetSavedFilter() {
  searchText.value = "";
  filterColumns.value = [];
  filteredRows = [];
  groupColumns.value = [];
  groupColumn.value = null;
  window.localStorage.setItem(localName, "");
  refreshFilter(true);
  await updateFilteredRows();
  emit("reloadData");
}

function checkChanged(fv: any) {
  fv.checked = !fv.checked;
  // $forceUpdate();
  emit("filterChanged");
  updateFilteredRows();
}

function getSearchText() {
  return searchText;
}

async function updateFilteredRows() {
  color.value = props.colorUbergabe ?? "white";
  if (
    (!enableFilter.value && !searchText.value) ||
    (!filterColumns && !searchText.value)
  ) {
    if (datarows) {
      filteredRows = datarows ? [...datarows] : [];
    } else {
      filteredRows = [];
    }
    const eventdata1: FilteredQueryResponse = {
      filterActive: false,
      header: props.queryData.header,
      data: [...filteredRows] as QueryData,
      columns: props.queryData.columns,
      error: props.queryData.error,
      searchText: searchText.value,
    };

    // if (eventdata1.filterActive !== false) {
    //   console.log("filterDataChanged - Filte Zeile 454");
    //   emit("filteredDataChanged", eventdata1);
    // }
    emit("filteredDataChanged", eventdata1);
    return;
  }

  const data = datarows;
  filteredRows = [];
  if (data && data.length > 0) {
    filteredRows = data.filter((row: any) => {
      let match = true;
      if (searchText.value) {
        color.value = "green";
        const search = searchText.value.toLowerCase();
        const inText = false;

        const containingColumn = searchTextColumns.find((c) => {
          let val = getDisplay(row, c);
          if (val) {
            val = val.toLowerCase();
            if (val.indexOf(search) >= 0) {
              return true;
            }
          }
          return false;
        });

        if (containingColumn) {
          match = true;
        } else {
          match = false;
        }
      }

      if (!filterColumns.value) {
        return true;
      }
      const col: any = filterColumns.value;
      // const colValue = col.filterValues;
      filterColumns.value.forEach((fc) => {
        const fv = getDisplay(row, fc) ?? emptyFilterText;
        const rowValue = getValue(row, fc);
        if (fc.type === "checkBox") {
          if (fc.filterSwitchValue) {
            color.value = "green";
            // wenn nicht dann alle
            const jaVal = getDisplayValue(true, fc);
            match = match && jaVal === fv;
          }
        } else if (fc.type === "slider") {
          const sl = getSlider(fc);
          if (!sl?.range) {
            return;
          }
          const min = sl.range[0] ?? sl.min;
          const max = sl.range[1] ?? sl.max;

          match = match && rowValue >= min && rowValue <= max;
          return;
          // }
          // else if (fc.type === "checkBox3" && initAll) {
          //   fc.filterValues.forEach((fx, ix) => {
          //     if (!fc.filterValues.find((f: any) => f.aic === f.meta.value)) {
          //       fc.filterValues.checked = false;
          //     }
          //   });
          //   // const check = filterValues.find((f: any) => f === fc.filterValues[i].aic);
        } else {
          const checkFilter = fc.filterValues?.find((ffv: any) => !ffv.checked);

          if (checkFilter) {
            color.value = "green";
          } else if (initAll.value && enableFilter.value) {
            color.value = "green";
          }
          if (fv === "- leer -") {
            // wenn keine Daten da sind dann trotzdem anzeigen!
            // match = true;  // einfach nix machn weil die andren suchkriterien gelten ja trotzdem.
          } else {
            match =
              match &&
              fc.filterValues?.find(
                (ffv: any) => ffv.value === fv && ffv.checked
              ) != null;
          }
        }
      });
      return match;
    });
  }
  let noData = false;
  if (filteredRows.length === 0 && color.value === "green") {
    showSnackbar({
      text: "es wurden keine Daten gefunden!",
      color: "warning",
    });
    noData = true;
  }
  const filteredRowsLocal = filteredRows.sort((a, b) => {
    if (a.group > b.group) {
      return 1;
    } else if (b.group > a.group) {
      return -1;
    }
    return 0;
  });
  let filterActive = true;
  // wurde für den Filter nix gefunden - dann auch nicht auf ACTIVE setzen!
  const filter2 = columns.find((c: any) => c.meta.filter2 === true);
  // parameter alternativer Filter bei der Spalte
  // dann sollen nicht nur MA mit Daten sondern ALLE angzeigt werden (Dienstoplan)
  if (filter2) {
    filterActive = false;
  }
  // info ob ein Filter eingeschalten wurde
  let filterSet = false;
  if (color.value === "green") {
    filterSet = true;
  }
  const eventdata: FilteredQueryResponse = {
    filterActive,
    header: props.queryData.header,
    data: [...filteredRows] as QueryData,
    columns: props.queryData.columns,
    error: props.queryData.error,
    searchText: searchText.value,
    filterSet,
    noData,
  };
  console.log("filterDataChanged zeile 572");
  emit("filteredDataChanged", eventdata);
}

async function groupColumnChanged(gv?: DataColumn) {
  if (gv === groupColumn.value) {
    gv = undefined;
  }
  groupColumn.value = gv ?? null;
  emit("groupColumnChanged", gv);
  emit("reloadData");
}

function setBooleanFilterValue(fc: FilteredDataColumn) {
  // fc.filterSwitchValue = value;
  // if (value) {
  //   const jaVal = getDisplayValue(true, fc);
  //   fc.filterValues!.forEach((fv) => (fv.checked = fv.value === jaVal));
  // } else {
  //   fc.filterValues!.forEach((fv) => (fv.checked = true));
  // }
  updateFilteredRows();
}

function countBooleanFilterableValues(fc: FilteredDataColumn) {
  let rows = datarows;
  if (filteredRows && filteredRows.length > 0) {
    rows = filteredRows as QueryData;
  }
  const setItemCount = rows?.filter(
    (item: QueryDataRow) => getValue(item, fc) === true
  ).length;

  return (setItemCount ?? "??") + "/" + (datarows?.length ?? "??");
}

function filterChanged() {
  updateFilteredRows();
}
function setdefaultFilter() {
  const localParameter: string = enableFilter.value.toString();
  window.localStorage.setItem(localName, localParameter);
  if (enableFilter.value) {
    emit("filterChanged");
    updateFilteredRows();
  } else {
    emit("filterChanged");
    resetFilter();
  }
}
function setIsWeg() {
  emit("setIsWeg", selectVorAustritt);
}
</script>
<template>
  <!-- Filter Menü -->
  <v-menu
    v-model="menu"
    v-if="filterColumns && filterColumns.length > 0"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ props }">
      <v-btn class="pa-0" variant="text" size="large" v-bind="props">
        <v-icon :color="color">mdi-filter-variant</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-actions>
        <v-tooltip
          location="bottom"
          :text="
            globalsBezeichnung(
              Globals.Begriff,
              'Web_Filter_aktivieren',
              'Filter aktivieren'
            )
          "
        >
          <template v-slot:activator="{ props }">
            <v-btn
              variant="text"
              v-bind="props"
              @click.stop="resetSavedFilter()"
              prepend-icon="mdi-backup-restore"
              text="Restore"
            >
            </v-btn>
          </template>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-btn
          varaiant="text"
          @click="resetFilter()"
          prepend-icon="mdi-restart"
          :text="begriffBezeichnung('Web_Reset')"
        >
        </v-btn>
        <v-btn
          varaiant="text"
          @click.stop="menu = false"
          prepend-icon="mdi-cancel"
          :text="begriffBezeichnung('Close')"
        >
        </v-btn>
      </v-card-actions>

      <v-text-field
        class="px-2"
        :label="globalsBezeichnung(Globals.Begriff, 'Suche', 'Suche')"
        variant="outlined"
        append-inner-icon="mdi-magnify"
        :hide-details="true"
        v-model="searchText"
        @input="updateFilteredRows()"
      ></v-text-field>
      <v-switch
        v-if="initAll"
        label="Filter ein/ausschalten"
        v-model="enableFilter"
        @change="setdefaultFilter"
        color="success"
        prepend-icon="mdi-filter"
      >
      </v-switch>
      <v-switch
        v-if="showVorAustritt"
        v-model="selectVorAustritt"
        @change="setIsWeg"
        color="success"
        label=" vor. Austritte"
      >
      </v-switch>

      <div class="overflow-y-auto" style="max-height: 600px">
        <div class="ma-2" v-for="(fc, ix) in filterColumns" :key="'fc' + ix">
          <v-list v-if="fc.type !== 'checkBox'" class="pa-0">
            <v-list-item>
              <v-list-item-title
                ><v-icon>mdi-filter-variant</v-icon>
                {{ fc.title }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <div
            v-if="
              fc.type === 'checkBox' && ((initAll && enableFilter) || !initAll)
            "
            class="pa-0"
          >
            <v-switch
              v-if="fc.type === 'checkBox'"
              prepend-icon="mdi-filter"
              v-model="fc.filterSwitchValue"
              color="warning"
              @update:modelValue="updateFilteredRows()"
            >
              <template v-slot:label>
                {{ fc.title }} ({{ countBooleanFilterableValues(fc) }})
              </template>
            </v-switch>
            <span v-else> <v-icon>mdi-filter</v-icon>{{ fc.title }}</span>
          </div>
          <div v-if="fc.type === 'slider'">
            <CommonBaseFilterSlider
              :config="getSlider(fc)"
              @change="updateFilteredRows"
            />
          </div>
          <div
            v-if="
              fc.type !== 'slider' &&
              fc.type !== 'checkBox' &&
              ((initAll && enableFilter) || !initAll)
            "
          >
            <v-list class="baselistFilterItems">
              <v-list-item
                v-for="(fv, iix) in fc.filterValues"
                :key="'fv' + ix + '_' + iix"
                @click="checkChanged(fv)"
              >
                <template v-slot:prepend>
                  <v-icon v-if="!fv.checked">mdi-checkbox-blank-outline</v-icon>
                  <v-icon color="primary" v-if="fv.checked"
                    >mdi-checkbox-outline</v-icon
                  >
                </template>
                <v-list-item-title>
                  <span v-html="fv.value"></span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <div v-if="groupColumns && groupColumns.length > 0">
          <v-list class="pa-0">
            <v-list-item>
              <template v-slot:prepend>
                <v-icon>mdi-format-list-group</v-icon>
              </template>
              <v-list-item-title>{{
                begriffBezeichnung("Web_gruppieren")
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list class="baselistFilterItems">
            <v-list-item
              v-for="(gv, iix) in groupColumns"
              :key="'gv' + iix"
              @click="groupColumnChanged(gv)"
            >
              <template v-slot:prepend>
                <v-icon v-if="gv != groupColumn"
                  >mdi-checkbox-blank-outline</v-icon
                >
                <v-icon color="primary" v-if="gv == groupColumn"
                  >mdi-checkbox-outline</v-icon
                >
              </template>

              <v-list-item-title>
                <span v-html="gv.title"></span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </div>
      <v-card-actions>
        <v-btn
          variant="text"
          color="green"
          @click.stop="setUserPara()"
          prepend-icon="mdi-filter"
          :text="
            globalsBezeichnung(
              Globals.Begriff,
              'Web_Einst_Speichern',
              'Speichern'
            )
          "
        >
        </v-btn>

        <v-btn
          variant="text"
          color="red"
          @click.stop="deleteUserPara()"
          prepend-icon="mdi-filter-remove"
          :text="
            globalsBezeichnung(
              Globals.Begriff,
              'Web_Einstellungen_Loeschen',
              'Löschen'
            )
          "
        >
        </v-btn>

        <!-- <v-col cols="12" sm="2" md="2" lg="2" class="pa-0">
            <v-tooltip location="bottom"
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="resetSavedFilter()"
                >
                  <v-icon>settings_backup_restore</v-icon>
                </v-btn>
              </template>
              <span>{{
                globalsBezeichnung(
                  Globals.Begriff,
                  "Web_Filter_aktivieren",
                  "Filter aktivieren"
                )
              }}</span>
            </v-tooltip>
          </v-col> -->
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
